import { createContext, useContext } from 'react';

interface CartModalContextProps {
  isOpen: boolean;
  toggleModal: (nextValue?: any) => void;
}

export const NftCartContext = createContext<CartModalContextProps | undefined>(
  undefined
);

export const useNftCartModal = () => {
  const context = useContext(NftCartContext);

  if (!context) {
    throw new Error('useNftCartModal must be used within a CartModalProvider');
  }

  return context;
};
